import { render, staticRenderFns } from "./SelectLift.vue?vue&type=template&id=53a1f546&scoped=true"
import script from "./SelectLift.vue?vue&type=script&lang=js"
export * from "./SelectLift.vue?vue&type=script&lang=js"
import style0 from "./SelectLift.vue?vue&type=style&index=0&id=53a1f546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a1f546",
  null
  
)

export default component.exports